import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { BrowserRouter } from 'react-router-dom'
import reducers from 'store/reducers'
import App from './app'
import './styles/app.css'

export const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunkMiddleware))
)

function AppWithRoutesAndRedux() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  )
}

ReactDOM.render(<AppWithRoutesAndRedux />, document.getElementById('app-root'))



// WEBPACK FOOTER //
// ./src/index.js